import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Outlet } from 'react-router-dom'
import { AuthFormValue } from 'pages/auth/type'

const AuthLandingPage = () => {
  const methods = useForm<AuthFormValue>({
    defaultValues: {
      email: '',
      password: ''
    }
  })
  return (
    <>
      <FormProvider {...methods}>
        <Outlet />
      </FormProvider>
    </>
  )
}

export default AuthLandingPage
